import { useEffect, useState } from 'react'
import { BirdLogo, IntegrationIcon, HubSpotIntRectIcon, HubSpotIcon, RightArrowBlueIcon, SyncArrowCycleIcon } from '../../../icon'
import ButtonComponent from '../../shared/button/button.component'
import { ToasterTexts, buttonLabels, pageTitles } from '../../shared/constants'
import { setBackHandler, setHeaderTitle } from '../../../helpers/header.helper'
import Config from '../../../config'
import { useLocation, useNavigate } from 'react-router'
import { UserService } from '../../../services/UserService'
import setToast from '../../../helpers/toaster.helper'
import { ToasterType } from '../../shared/toaster/toaster.model'
import { AppRoutes, TeamsRoutes, } from '../../routes/route.path'
import { IntegrationSetupService } from '../../../services/IntegrationSetup'
import { ContactService } from '../../../services/ContactService'
// import { SucessOutlineIcon } from '../../../icon'
import * as selector from "../../../selectors/selectors";
import { useSelector } from 'react-redux'
import { app, authentication } from "@microsoft/teams-js";
import { Autocomplete, Checkbox, TextField } from '@mui/material'
import { HubspotPrimaryKeyType, PhoneNumberModel, } from '../../../models/phone-number.model'
import { UtilityService } from '../../../services/UtilityService'
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import AnimateLoader from "../../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../../shared/loaders/message-logs-search-inprogress-loader.json";
import { TimeZoneModel } from '../../../models/settings-model'
import CustomSwitch from '../../shared/switch.component'

const HubSpotSetup = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const OrgRef = UserService.getCurrentUserOrgRef()
    const OrgId = UserService.getCurrentUserOrgId()
    const Phonenumber = UserService.getUserPhoneNumber()
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const IsContactSyncing = useSelector(selector.IscontactsSyncing)
    const IsGroupContactSyncing = useSelector(selector.IsGroupContactsSyncing)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);

    const [isConnected, setIsconnected] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [syncContactsLoading, setSyncContactsLoading] = useState<boolean>(false)
    const [syncGroupLoading, setSyncGroupLoading] = useState<boolean>(false)
    const [data, setdata] = useState<{
        phonenumbers: any[]
        primaryKey: HubspotPrimaryKeyType
        timeZone: TimeZoneModel
        isCompanySync: boolean
    }>()
    const [selectedPhonenumbers, setSelectedPhonenumbers] = useState<any[]>([]);
    const [primaryKey, setPrimaryKey] = useState<HubspotPrimaryKeyType>(HubspotPrimaryKeyType.PhoneNumber)
    const [conversationsync, setConversationsync] = useState<{
        syncInbound: boolean,
        syncOutbound: boolean
    }>({
        syncInbound: true,
        syncOutbound: true
    })
    const [timeZone, setTimeZone] = useState<TimeZoneModel | null>(null);
    const [isCompanySync, setIsCompanySync] = useState<boolean>(false)

    let timeZonesTypes = UtilityService.getTimeZones();


    useEffect(() => {
        setHeaderTitle(pageTitles.HUBSPOT);
        setBackHandler(() => navigate(AppRoutes.INTEGRATIIONS))
        if (!!location.search) {
            const params = new URLSearchParams(location.search);

            setIsconnected(params.get('connection') === 'true')
        }
        if (isConnected === true) {
            setToast(ToasterTexts.HUBSPOT_CONNECTION_SUCCESS, ToasterType.SUCCESS)
        }
    }, [location?.search])

    // useEffect(() => {
    //     if (isConnected === true) {
    //         const data = {
    //             OrgId: OrgId,
    //             name: IntegrationLabels.HUBSPOT,
    //             integrationCode: IntegrationSetupService.HubSpotIntegration_Code,
    //             integrationStatus: isConnected
    //         }
    //         IntegrationSetupService.updateIntegrationStatus(data).then((res) => console.log(res)).catch()
    //     }
    // }, [isConnected])

    useEffect(() => {
        if (isConnected === true && !!PhoneNumbers?.length) {
            IntegrationSetupService.getHubspotConfig().then((res => {
                setIsLoading(false)
                const timeZone = timeZonesTypes?.find(x => x.Name === res.data.timeZone)
                setdata({
                    ...data,
                    phonenumbers: PhoneNumbers.filter(x => res.data.phoneNumbers?.includes(x.PhoneNumber)),
                    primaryKey: res.data.phoneNumberType,
                    timeZone: timeZone,
                    isCompanySync: res.data.isCompanySync
                })
                setSelectedPhonenumbers(PhoneNumbers.filter(x => res.data.phoneNumbers?.includes(x.PhoneNumber)))
                setPrimaryKey(res.data.phoneNumberType)
                setTimeZone(timeZone || null)
                setIsCompanySync(res.data.isCompanySync)
            })).catch();
        }
    }, [isConnected, PhoneNumbers])

    const connectToHubSpot = () => {
        if (IsTeamsApp) {
            app.initialize()
            authentication.authenticate({
                url: TeamsRoutes.HUBSPOT_POPUP,
                width: 800,
                height: 600,
                successCallback: (result) => {
                    navigate(AppRoutes.HUBSPOT + `?connection=${true}`)
                },
                failureCallback: (reason) => {
                    console.error('Authentication failed:', reason);
                }
            })
        }
        else {
            window.location.href = `${Config.API_URL}/api/HubSpot/Connect?OrgRef=${OrgRef}&OrgId=${OrgId}&PhoneNumber=${Phonenumber}`;
        }

    }

    const disconnect = () => {
        IntegrationSetupService.disConnectHubSpot(OrgRef, OrgId).then(
            (res) => {
                setIsconnected(false)
                navigate(AppRoutes.HUBSPOT + `?connection=${false}`)
                setToast(ToasterTexts.HUBSPOT_DISCONNECT, ToasterType.SUCCESS);
                // const data = {
                //     OrgId: OrgId,
                //     name: IntegrationLabels.HUBSPOT,
                //     integrationCode: IntegrationSetupService.HubSpotIntegration_Code,
                //     integrationStatus: false
                // }
                // IntegrationSetupService.updateIntegrationStatus(data).then((res) => console.log(res)).catch()
            }).catch((err) => { setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER) })
    }

    const SyncContacts = () => {
        setSyncContactsLoading(true)
        ContactService.copyContactToHubSpot().then(res => {
            setSyncContactsLoading(false);
        }
        ).catch((err) => {
            if (!!err?.response?.data.message) setToast(err?.response?.data.message, ToasterType.DANGER);
            setSyncContactsLoading(false);
        })
    }

    const syncGroupContactsToHubSpot = () => {
        setSyncGroupLoading(true)
        ContactService.copyGroupContactToHubSpot().then(() => {
            setSyncGroupLoading(false)
        }).catch((err) => {
            if (!!err?.response?.data.message) setToast(err?.response?.data.message, ToasterType.DANGER);
            setSyncGroupLoading(false)
        })
    }

    const handleSave = () => {
        let data = {
            "phoneNumbers": selectedPhonenumbers.map(x => x.PhoneNumber),
            "phoneNumberType": primaryKey,
            "timeZone": timeZone?.Name,
            "isCompanySync": isCompanySync,
        }
        setIsLoading(true)
        console.log(data);

        IntegrationSetupService.updateHubspotConfig(data).then((res) => {
            setIsLoading(false)
            setSelectedPhonenumbers(PhoneNumbers.filter(x => res.data.phoneNumbers.includes(x.PhoneNumber)))
            setPrimaryKey(res.data.phoneNumberType)
            setTimeZone(timeZonesTypes?.find(x => x.Name === res.data.timeZone) || null)
            setIsCompanySync(res.data.isCompanySync)
            setToast(ToasterTexts.HUBSPOT_SETTINGS_UPDATED, ToasterType.SUCCESS)
        }).catch()
    }

    const handleCancel = () => {
        setSelectedPhonenumbers(data.phonenumbers)
        setPrimaryKey(data.primaryKey)
        setTimeZone(data.timeZone)
        setIsCompanySync(data.isCompanySync)
    }

    const handleTimeZone = (event: any, value: any | null) => {
        if (value) {
            setTimeZone({ ...value } as TimeZoneModel)
        }
        else {
            setTimeZone({ ...value } as TimeZoneModel)
        }
    }

    const handleSwitch = (checked) => {
        setIsCompanySync(checked)
    }

    return (
        <div className='d-flex w-p-100 h-p-100  bg-color-profile-primary-background'>
            <div className="d-flex flex-direction w-fill h-fill m-1 br-1 o-y-scroll h-p-100 o-x-hidden">
                <div className="d-flex w-fill br-2 bg-color-secondary mt-1 mx-1">
                    <div className='d-flex align-center justify-between mt-1 mb-1'>
                        <span className="my-auto mx-2 "><HubSpotIntRectIcon /></span>
                        <span className="h1-semibold my-auto">HubSpot</span>
                        <span className="my-auto mx-2"><IntegrationIcon /></span>
                        <span className="my-auto mx-2"><BirdLogo /></span>
                    </div>
                    {
                        isConnected && <div className="d-flex my-auto ml-auto mr-3">
                            <ButtonComponent Variant={IsContactSyncing ? "disabled-btn" : "primary-btn"}
                                Loading={syncContactsLoading}
                                OnClick={SyncContacts}
                                Type="button"
                                ButtonLabel={IsContactSyncing ? buttonLabels.SYNCING : buttonLabels.SYNC_ALL_CONTACTS}
                                ClassName='mx-2'
                            />

                            <ButtonComponent Variant={"secondary-btn"}
                                OnClick={disconnect}
                                Type="button"
                                ButtonLabel={buttonLabels.DISCONNECT}
                            />
                        </div>
                    }
                </div>
                <div className="d-flex justify-around w-p-100 my-2 flex-wrap h-p-100 align-center">
                    {isConnected === false ?
                        <div className='d-flex align-center justify-between pl-2 pr-2 bg-color-settings-background p-2'>
                            <div className='paper-background h-23 min-w-75 dialogue-shadow br-1 p-2'>
                                <HubSpotIcon className=" h-4 w-8 ml-1" />
                                <div className='bb-primary-divider-4 opacity-1' />
                                <div className='d-flex align-center justify-center justify-between h-20'>
                                    <div className='pl-1 max-w-48 d-flex flex-direction'>
                                        <span className='h5-regular'>
                                            HubSpot integration enables seamless synchronization of customer contacts between Falkon SMS and HubSpot accounts.
                                            Additionally, customer conversations (text messages) will be instantly synced with the corresponding HubSpot contact cards.
                                        </span>
                                        <span className='h5-regular'>
                                            Click the 'Connect' button to set up the integration. You will be prompted to log in to hubspot and approve the integration.
                                        </span>
                                    </div>
                                    <ButtonComponent
                                        ButtonLabel={buttonLabels.CONNECT_HUBSPOT}
                                        ClassName={"br-5 max-w-21 h6-regular mr-2"}
                                        Variant={"secondary-btn-small"}
                                        OnClick={connectToHubSpot}
                                    />
                                </div>
                            </div>
                        </div> :
                        <div className='d-flex flex-direction mx-2 align-center justify-between pl-1 pr-1 bg-color-settings-background p-1 br-2 w-p-100'>
                            <div className='paper-background dialogue-shadow br-1 p-2 o-y-scroll w-p-100'>
                                {/* <div className='d-flex justify-center '>
                                    <span className='h3-regular color-contact-active'>HubSpot Integration is Live!</span>
                                </div>
                                <div className='d-flex flex-direction pt-2'>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'>
                                            New contacts added to your Falkon SMS phone numbers will be directly added to your HubSpot account contacts in real-time.</div>
                                    </div>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'>
                                            New contacts added to your HubSpot contacts will be directly added to your Falkon SMS accounts (phone numbers) in real-time.</div>
                                    </div>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'>To manually sync contacts between Falkon SMS phone numbers and HubSpot contacts, use the ' Sync all contacts ' button.</div>
                                    </div>
                                    <div className='d-flex'>
                                        <SucessOutlineIcon className="h-1 pt-1" />
                                        <div className='h5-regular'> Both outbound and inbound messages in your Falkon SMS will be added to the respective HubSpot contact's communications log (email log).</div>
                                    </div>
                                    <div className='pt-2 pl-1' >
                                        <span className='h5-bold color-vigenary-light pr-1'>Note:</span>
                                        <span className='h5-regular'>
                                            Message sync starts with messages sent after the integration is activated. Previous message history will not be included. Only messages associated with contacts
                                            already existing in HubSpot  will be synced. During contact sync, if duplicate contact numbers are present, they will not be added.
                                        </span>
                                    </div>
                                </div> */}
                                <div className='d-flex '>
                                    <span className='h3-bold '>Integration Settings</span>
                                </div>
                                <div className='d-flex flex-direction mt-1'>
                                    <div className='h4-semibold'> Falkon phone numbers (select numbers to enable contact & conversation sync)</div>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        className='mt-1'
                                        classes={{ input: 'h5-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={PhoneNumbers}
                                        getOptionLabel={(option) => UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber) + ` (${option?.Name})`}
                                        value={selectedPhonenumbers}
                                        onChange={(event, selectedOption) => {
                                            setSelectedPhonenumbers(selectedOption);
                                        }}
                                        // loading={IsLoading}
                                        renderOption={(defaultprops, option: any, { selected }) => (
                                            <li {...defaultprops}>
                                                <Checkbox
                                                    name="checkbox"
                                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                    style={{ color: selected ? '#1450FF' : "" }}
                                                    checked={selected}
                                                />
                                                <span className={" c-pointer color-menu-list-font-color w-p-92"}>
                                                    <div className={`h5-regular ${!selector.isDarkMode ? "color-switchUIoption" : ""}`}> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
                                                    <div className='h5-regular color-nav-bar-font-color'>{option?.Name} </div>
                                                </span>
                                            </li>
                                        )}
                                        renderInput={(params) =>
                                            <TextField {...params} name="phoneNumberId" required variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <div className='pl-2 mt-1 w-3'> {isLoading && <AnimateLoader LoaderAnimation={messagsLogsLoader} />}
                                                            {params.InputProps.endAdornment}
                                                        </div>
                                                    ),
                                                }}
                                            />}
                                    />
                                </div>

                                <div className='d-flex  flex-direction pt-1'>
                                    <div className='h4-semibold'> Primary attribute for matching contacts in HubSpot</div>
                                    <RadioGroup
                                        value={primaryKey}
                                        onChange={(e) => setPrimaryKey(Number(e.target.value))}
                                    >
                                        <FormControlLabel
                                            value={HubspotPrimaryKeyType.PhoneNumber}
                                            control={<Radio color="primary" />}
                                            label="Phone Number"
                                        />

                                        <FormControlLabel
                                            value={HubspotPrimaryKeyType.MobileNumber}
                                            control={<Radio color="primary" />}
                                            label="Mobile Phone Number"
                                        />

                                    </RadioGroup>
                                    <div className='h6-regular color-con-hist-msg-date'> If Mobile Phone Number is selected, Falkon will first try matching on HubSpot's Mobile Phone field and fall back to Phone if no match is found.</div>
                                </div>
                                <div className='d-flex flex-direction  pt-1 mt-2'>
                                    <div className='h4-semibold'> Conversation sync</div>
                                    <div className="d-flex flex-direction mt-1">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={conversationsync.syncInbound}
                                                    onChange={(e) => setConversationsync({ ...conversationsync, syncInbound: e.target.checked })}
                                                    // classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                    // style={{ color: !!conversationsync.syncInbound  ? '#1450FF' : " " }}
                                                    disabled={true}
                                                />}
                                            label="Sync inbound messages" />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={conversationsync.syncOutbound}
                                                    onChange={(e) => setConversationsync({ ...conversationsync, syncOutbound: e.target.checked })}
                                                    // classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                    // style={{ color: !!conversationsync.syncOutbound ? '#1450FF' : " " }}
                                                    disabled={true}
                                                />}
                                            label="Sync outbound messages" />
                                    </div>
                                    <div className='h6-regular color-con-hist-msg-date'> Logged messages will appear as timeline notes on HubSpot contact records.</div>

                                </div>
                                <div className='d-flex flex-direction  pt-1 mt-2'>
                                    <div className='h4-semibold'> Message Sync Timezone</div>
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: ` color-text-field-font `, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={timeZonesTypes}
                                        className='mt-2'
                                        getOptionLabel={(option: TimeZoneModel) => option && option.OffsetLabel && option.Name ? `(${option.OffsetLabel}) ${option.Name}` : ""}
                                        onChange={handleTimeZone}
                                        value={timeZone}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} data-name={option.Name} className={`c-pointercolor-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                                ({option.OffsetLabel}) {option.Name}
                                            </li>
                                        )}
                                        onOpen={() => {
                                            setTimeout(() => {
                                                const element = document.querySelector(
                                                    `[data-name="${timeZone?.Name}"]`
                                                );
                                                element?.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });

                                            }, 0);
                                        }}
                                        renderInput={(params) => <TextField {...params} name="Time Zone" variant="outlined" label="Time Zone" placeholder="Time Zone" />}
                                    />
                                    <div className='h6-regular color-con-hist-msg-date'> Select the timezone to be used when syncing message timestamps to HubSpot.</div>
                                </div>
                                <div className='d-flex flex-direction  pt-1 mt-2'>
                                    <div className='d-flex justify-between '>
                                        <div className='h4-semibold'> Sync Messages to Contact's Primary Organization</div>
                                        <CustomSwitch
                                            checked={isCompanySync}
                                            onChange={(checked: boolean) => handleSwitch(checked)}
                                        />
                                    </div>
                                    <div className='h6-regular color-con-hist-msg-date pt-1'>When enabled, messages will be synced only to the contact's primary organization in HubSpot.</div>

                                </div>
                                <div className='d-flex pt-2 justify-flex-end'>
                                    <ButtonComponent OnClick={handleSave} Loading={isLoading} ButtonLabel={buttonLabels.SAVE} ClassName={`c-pointer  mr-1 w-p-10 justify-center mb-2 mr-2 br-1`} Variant={"primary-btn-small"} />
                                    <ButtonComponent OnClick={handleCancel} ButtonLabel={buttonLabels.CANCEL} ClassName={`c-pointer 'w-p-10 justify-center  mb-2 br-1`} Variant={"secondary-btn-small"} />
                                </div>
                            </div>

                            <div className='paper-background dialogue-shadow br-1 p-2 w-p-100 mt-2'>
                                <div className='d-flex align-center justify-start'>
                                    <span className='h3-bold '>Groups Sync</span>
                                    <span className='ml-1 py-0 h-p-5 d-flex align-center justify-center h5-medium color-secondary bg-color-button-text px-1 br-3'>New</span>
                                </div>
                                <div className='d-flex align-start justify-start mt-1 br-2 mt-1 p-1 pr-2 pt-1' style={{ border: "1px solid #EBECF1" }}>
                                    <div className='mr-1 br-2 bg-color-primary-light-blue w-5 h-5 d-flex align-center justify-center mt-1'><RightArrowBlueIcon style={{ width: "1.2rem", height: "1.2rem" }} /></div>

                                    <div className='d-flex flex-direction align-start justify-start pt-1 mt-1'>
                                        <span className='h4-regular'>Manually pull your HubSpot contact lists to create targeted messaging groups in Falkon. This is a one-way sync from HubSpot to Falkon.</span>
                                        <ButtonComponent Variant={IsGroupContactSyncing ? "disabled-btn" : "secondary-btn"}
                                            Loading={syncGroupLoading}
                                            OnClick={syncGroupContactsToHubSpot}
                                            Icon={SyncArrowCycleIcon}
                                            Type="button"
                                            ButtonLabel={IsGroupContactSyncing ? buttonLabels.SYNCING : buttonLabels.SYNC_GROUP_CONTACTS}
                                            ClassName=''
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

            </div>

        </div>)
}
export default HubSpotSetup
